export default {
  methods: {
    hasState(prop) {
      return (
        typeof this[prop] !== 'undefined' &&
        this[prop] !== false &&
        this[prop] !== 'false'
      );
    },
  }
};
